<template>
  <admin-card title="Управление курсами">
    <table class="table table-striped table-bordered admin-table">
      <thead>
      <tr>
        <th colspan="5" class="admin-table__controls">
          <router-link :to="{ name: createRoute }" class="btn btn-primary" active-class="active">
            Создать
          </router-link>
        </th>
      </tr>
      <tr>
        <th>ID</th>
        <th>Название</th>
        <th>Автор курса</th>
        <th>Преподаватель</th>
        <th>Управление</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="course in courses">
        <td>{{ course.id }}</td>
        <td>{{ course.title }}</td>
        <td>{{ course.author.name }}</td>
        <td>{{ course.teacher_id }}</td>
        <td>
          <a :href="'/courses/' + course.id" target="_blank" class="btn btn-default">
            На сайте
          </a>
          <router-link :to="{ name: editRoute, params: { id: course.id } }"
                       class="btn btn-primary"
                       active-class="active">
            Редактировать
          </router-link>
          <button class="btn btn-warning" @click.prevent="removeCourse(course)">Удалить</button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="5" class="admin-table__controls">
          <router-link :to="{ name: createRoute }" class="btn btn-primary" active-class="active">
            Создать
          </router-link>
        </th>
      </tr>
      </tfoot>
    </table>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AdminPage from "../admin-page";
  import RoutingService from '../../../services/routing';

  export default {
    metaInfo () {
      return { title: 'Курсы' }
    },
    extends: AdminPage,
    data: () => ({
    }),
    computed: {
      ...mapGetters({
        courses: 'courses/courses',
        userRole: 'auth/role',
      }),
      editRoute: function () {
        return RoutingService.getRoleRoute('admin.course.edit', this.userRole);
      },
      createRoute: function () {
        return RoutingService.getRoleRoute('admin.course.add', this.userRole);
      }
    },
    methods: {
      async removeCourse (course) {
        if (confirm('Вы уверены, что хотите удалить курс "' + course.title + '"?')) {
          await this.$store.dispatch('courses/remove', course.id);
        }
      }
    },
    async beforeMount () {
      this.$store.dispatch('courses/fetchMyCourses');
    }
  }
</script>
